import type { UserDataLoginRecord } from '@navio/nsdk';

type UserGroupMembership = Pick<UserDataLoginRecord['userGroups'][number], 'id' | 'isDefaultUserGroup' | 'isSelected'>;

// The group a session acts as. A stored id is kept only while the user is still a member of it;
// otherwise default group, then the selected (personal) one, then the only group there is.
// Undefined means the user has to pick one.
export const resolveCurrentUserGroupId = (
  userGroups: readonly UserGroupMembership[],
  storedUserGroupId?: number
): number | undefined => {
  if (storedUserGroupId && userGroups.some((userGroup) => userGroup.id === storedUserGroupId)) {
    return storedUserGroupId;
  }
  return (
    userGroups.find((userGroup) => userGroup.isDefaultUserGroup) ??
    userGroups.find((userGroup) => userGroup.isSelected) ??
    (userGroups.length === 1 ? userGroups[0] : undefined)
  )?.id;
};

// Impersonation never shows a picker: when nothing qualifies, any membership beats none.
export const resolveImpersonatedUserGroupId = (
  userGroups: readonly UserGroupMembership[],
  storedUserGroupId?: number
): number | undefined => resolveCurrentUserGroupId(userGroups, storedUserGroupId) ?? userGroups[0]?.id;
